var map = {
	"./ata-exame/routes.ts": "./src/router/ata-exame/routes.ts",
	"./dashboard/routes.ts": "./src/router/dashboard/routes.ts",
	"./exame-aluno/routes.ts": "./src/router/exame-aluno/routes.ts",
	"./exame-turma/routes.ts": "./src/router/exame-turma/routes.ts",
	"./parametrizacao-exames/exame-amparo-rede/routes.ts": "./src/router/parametrizacao-exames/exame-amparo-rede/routes.ts",
	"./relatorios-pendencias-exames/routes.ts": "./src/router/relatorios-pendencias-exames/routes.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router sync recursive routes.ts$/";